// import { LoadingButton } from "@mui/lab";
// import { func } from "prop-types";
// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import BookingApi from "../../API/Apis/BookingApi";
import BookingDetalisListSideNavigation from "../../components/Layouts/ReservationsCard/BookingDetalisListSideNavigation";
// import ReservationCard from "../../components/Layouts/ReservationsCard/ReservationsCards";
import { AppStandardButton } from "../../components/UI/AppButtons";
// import NotAuthorisedPage from "../notAuthorisedPage";
import BookingCard from "./BookingCard";
// import BookingGetters from "../../store/onlineBooking/getters";
import { t } from "i18next";

export default function MyReservationsPage() {
  return (
    <div>
      <AppStandardButton
        href="/"
        className={"flex justify-end mr-1"}
        sx={{
          width: 200,
          "& .css-9pkl4c-MuiButtonBase-root-MuiButton-root": {
            textAlign: "end",
          },
        }}
        variant="contained"
        color="primary"
        style={{ borderRadius: "5" }}
      >
        <span className="normal-case text-lg">Book Now</span>
      </AppStandardButton>
      <div className="flex mt-12 mr-6 h-480 max-h-screen ">
        <BookingDetalisListSideNavigation />
        <div>
          <div className="container  mx-4">
            <div className="flex flex-col   ">
              <div className="flex justify-between space-x-2 mb-8  ">
                <div>
                  <h1
                    className="font-medium text-[36px] text-[#232323]"
                    style={{ fontFamily: "MBCorpoAScreen1Cond-Regular-Web" }}
                  >
                    {t("Booking Details")}
                  </h1>
                  <h4
                    className="text-[#838181] font-normal text-[20px]"
                    style={{ fontFamily: "MBCorpoAScreen1Cond-Regular-Web" }}
                  >
                    {t("Here is your booking details")}
                  </h4>
                </div>
              </div>
              <div>
                <BookingCard></BookingCard>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
